import React from 'react'
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import MobileOffIcon from '@material-ui/icons/MobileOff';
import {Link} from "react-router-dom";
import CuentaSelected from '../../helpers/CuentaSelected';

class ValidateDigitalInvoice extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            required: true,
        }
    }
        
    handleAccount = async (val) => {
        CuentaSelected.set(val);
    }
    
    render() {
        const {account, validateDigital} = this.props;

        return (
            <div>
                {
                    validateDigital===null ?
                    <div>
                        <Tooltip
                            title="Factura digital">
                            
                            <Link to='create-digital-invoice' variant="body2">
                                <IconButton color="primary"
                                    onClick={() => {
                                        this.handleAccount(account)
                                    }}>
                                    <MobileOffIcon fontSize='large'/>
                                </IconButton>
                            </Link>
                            
                        </Tooltip>
                        <span style={{
                            fontSize: '11px',
                            fontStyle: 'italic',
                            display: 'block'
                        }}>Factura digital</span>
                    </div>
                    :
                    <div>
                        <Tooltip
                            title="Factura digital">
                            
                            <Link to='modify-digital-invoice' variant="body2">
                                <IconButton color="secondary"
                                    onClick={() => {
                                        this.handleAccount(account)
                                    }}>
                                    <MobileFriendlyIcon fontSize='large'/>
                                </IconButton>
                            </Link>
                            
                        </Tooltip>
                        <span style={{
                            fontSize: '11px',
                            fontStyle: 'italic',
                            display: 'block'
                        }}>Factura digital</span>
                    </div>

                }
            </div>

        );
    }
}

export default ValidateDigitalInvoice